/*global define*/

define("collections/Workbench", [
    'underscore',
    'backbone',
    'models/Workbench'
], function (_, Backbone, WorkbenchModel) {
    'use strict';

    var WorkbenchCollection = Backbone.Collection.extend({
        model: WorkbenchModel
    });

    return WorkbenchCollection;
});
